import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

export enum WorkLogPayerTabFilterStatus {
  ToApprove = "to-approve",
  InProgress = "in-progress",
  Approved = "approved",
  Rejected = "rejected"
}

export interface Filter extends UrlQueryFilter {
  payeeEngagementId?: string;
  status?: WorkLogPayerTabFilterStatus;
}
